import gql from 'graphql-tag'

export const GET_CATEGORY_NAVIGATION = gql`
  query GetCategoryNavigation {
    categoryNavigation {
      id
      children {
        categoryId
        categoryDisplayName
        categoryEnglishDisplayName
        url
        children {
          categoryId
          categoryDisplayName
          categoryEnglishDisplayName
          url
          children {
            categoryId
            categoryDisplayName
            categoryEnglishDisplayName
            url
          }
        }
      }
    }
  }
`

export const GET_CATEGORY_NAVIGATION_SHALLOW = gql`
  query GetCategoryNavigationShallow {
    categoryNavigation {
      id
      children {
        categoryId
        categoryDisplayName
        categoryEnglishDisplayName
        url
      }
    }
  }
`
